import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "./auth/AuthContext";
import NotificationsPanel from "./notifications/NotificationsPanel";
import { getUnreadCount } from "./notifications/NotificationService";
import "./Header.css";

export default function Header({ pendingReviewCount = 0, holdReviewCount = 0, onReviewClick }) {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();
  const displayName = auth?.username || "Guest";
  const isAdminRole = ["OWNER", "ADMIN", "SUPPORT", "READ_ONLY"].includes(auth?.role);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    let timer;
    const load = async () => {
      if (!auth?.token) {
        setUnreadCount(0);
        return;
      }
      const count = await getUnreadCount();
      setUnreadCount(count);
    };
    load();
    timer = setInterval(load, 30000);
    return () => clearInterval(timer);
  }, [auth?.token]);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="page-header app-header">
      <h1 className="app-header-title">LifeOS</h1>
      {auth?.token && (
        <div className="app-header-actions">
          <div className="app-header-user">Hi, {displayName}</div>
          {(pendingReviewCount > 0 || holdReviewCount > 0) && (
            <button
              className="app-header-review"
              type="button"
              onClick={() => onReviewClick?.()}
            >
              Review pending ({pendingReviewCount})
              {holdReviewCount > 0 && <span className="app-header-review-hold">On hold {holdReviewCount}</span>}
            </button>
          )}
          <button className="app-header-search" type="button" onClick={() => navigate("/search")}>
            Search
          </button>
          <button
            className="app-header-bell"
            type="button"
            onClick={() => setNotificationsOpen((prev) => !prev)}
          >
            🔔
            {unreadCount > 0 && <span className="app-header-bell-badge">{unreadCount}</span>}
          </button>
          {isAdminRole && (
            <button className="app-header-admin" type="button" onClick={() => navigate("/admin")}>
              Admin
            </button>
          )}
          <button className="app-header-logout" type="button" onClick={handleLogout}>
            Sign out
          </button>
        </div>
      )}
      {auth?.token && (
        <NotificationsPanel
          open={notificationsOpen}
          onClose={() => setNotificationsOpen(false)}
        />
      )}
    </header>
  );
}
